<script>
import BusinessProcess from "@/mixins/BusinessProcess";
import VBtnMenu from "@/components/commonComponents/VBtnMenu.vue";
import VBtnMenuItem from "@/components/commonComponents/VBtnMenuItem.vue";

export default {
    name: "BpStatusStepper",
    components: {
        VBtnMenuItem,
        VBtnMenu,
    },
    props: {
        data: {
            type: Object,
        },
        publishedUrl: {
            type: String,
        },
        publishedUrlTooltip: {
            type: String,
        },
        publishedBitrixUrl: {
            type: String,
        },
    },
    mixins: [
        BusinessProcess,
    ],
    data() {
        return {};
    },
    computed: {
        stepperStep() {
            if (!this?.data?.approve_mask) {
                return 0;
            }

            return this.getBusinessProcessState(this.data.approve_mask, 'step');
        },
    },
    methods: {},
}
</script>

<template>
    <v-stepper flat class="bp-status-stepper">
        <v-stepper-header>
            <v-stepper-step
                :complete="stepperStep >= 1"
                step="1"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <span
                            v-on="on"
                        >
                            Создано
                        </span>
                    </template>
                    <span>
                        <template v-if="data && data.created_at">
                            {{ data.created_at | moment('DD.MM.Y HH:mm:ss') }}
                            <template v-if="data.created_by_name">, {{ data.created_by_name }}</template>
                        </template>
                    </span>
                </v-tooltip>
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="stepperStep >= 2"
                step="2"
            >
                В работе<br/>(автостатус)
            </v-stepper-step>

            <v-divider></v-divider>

            <template v-if="data.bp_is_declined && stepperStep === 2.5">
                <v-stepper-step
                    :rules="[() => false]"
                    step="2.5"
                    error-icon="mdi-alert-octagon"
                >
                    Отклонено
                </v-stepper-step>

                <v-divider></v-divider>
            </template>

            <v-stepper-step
                :complete="stepperStep >= 3"
                step="3">
                Предложено <br/>к публикации
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="stepperStep >= 4"
                step="4">
                Отправлено <br/>на утверждение
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="stepperStep >= 5"
                step="5">
                Одобрено
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="stepperStep >= 6"
                step="6">
                Ожидает <br/>публикации<br/>(автостатус)
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                step="7"
                :complete="!!publishedUrl && stepperStep >= 7"
            >
                <v-tooltip top v-if="!!publishedUrl">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn-menu color="primary"
                               v-bind="attrs"
                               v-on="on"
                               :href="publishedUrl"
                               target="_blank"
                               class="v-btn-with-menu"
                        >
                            Опубликовано
                            <template v-slot:menu>
                                <v-btn-menu-item
                                    :href="publishedUrl"
                                    target="_blank"
                                >
                                    ... на Портале
                                </v-btn-menu-item>
                                <v-btn-menu-item
                                    v-if="publishedBitrixUrl"
                                    :href="publishedBitrixUrl"
                                    target="_blank"
                                >
                                    ... в CMS Битрикс
                                </v-btn-menu-item>
                            </template>
                        </v-btn-menu>
                    </template>
                    <span>
                        {{ publishedUrlTooltip }}
                        <!--
                        @TODO Дата публикации (есть в revisions), но нужна ли она кому-то?
                        -->
                    </span>
                </v-tooltip>
                <template v-else>
                    Опубликовано
                </template>
            </v-stepper-step>
        </v-stepper-header>
    </v-stepper>
</template>

<style scoped lang="scss">
.v-stepper::v-deep {
    min-width: 50%;
    width: calc(100% - 200px);

    .v-stepper__header {
        height: auto;
        justify-content: flex-end;
    }

    .v-stepper__step {
        padding: 10px 24px;
        font-size: 10px;
        line-height: 1;
        font-weight: 100;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            padding-right: 0;
        }

        .v-icon.mdi-alert-octagon {
            font-size: 34px;
        }

        .v-stepper__label {
            .v-btn {
                .v-btn__content {
                    font-size: 10px !important;
                    line-height: 1;
                }
            }
        }
    }
}

</style>
